var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 123,
    viewBox: "0 0 318 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.875 0H318V139H-0.875V0Z",
    fill: "#6FF2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_151",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 318,
    height: 139
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H318V139H0V0Z",
    fill: "#000000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_151)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 76.866,
    height: 250.851,
    transform: "matrix(0.930396 -0.366556 0.645905 0.763418 -65.4554 -65.4697)",
    fill: "url(#paint0_linear_27_151)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 76.866,
    height: 219.203,
    transform: "matrix(-0.930396 0.366556 -0.645905 -0.763417 399.1 195.344)",
    fill: "url(#paint1_linear_27_151)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_151",
    x1: 38.433,
    y1: 9.94858e-8,
    x2: 49.3231,
    y2: 287.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_151",
    x1: 38.433,
    y1: 8.69345e-8,
    x2: 46.7514,
    y2: 251.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCool);
export default __webpack_public_path__ + "static/media/cool.3b4d5987d8fff93a90f9175ec4f94f08.svg";
export { ForwardRef as ReactComponent };